<template>
  <div class="mIndex">
    <!-- 全局加载遮罩 -->
    <div v-if="globalLoading" class="global-loading-mask">
      <div class="loading-spinner"></div>
    </div>
    <div class="logoTitle">
      <img src="@/assets/images/jwActivity/logo_title.png" alt="logo" />
    </div>
    <!--    <div class="title">-->
    <!--      <img src="@/assets/images/jwActivity/rule_title.png" alt="活动标题" />-->
    <!--    </div>-->
    <!--    <div class="date">2026.03.01-03.31</div>-->
    <div class="ruleContent">
      <img src="@/assets/images/jwActivity/rule_content.png" alt="活动内容" />
    </div>
    <div class="submit" @click="submit">立即报名</div>
  </div>
</template>

<script>
export default {
  name: "jwActivity",
  data() {
    return {
      globalLoading: false,
      homeVo: {},
      indexVo: {},
    };
  },
  async created() {
    // 页面加载时执行jwState判断
    try {
      // 显示加载状态，提升用户体验
      this.globalLoading = true;
      const isOk = await this.$store.dispatch("jwState");
      if (isOk) {
        // 如果状态满足，直接跳转到排名页面
        await this.$router.replace("/jwRank");
      }
    } catch (error) {
      console.error("jwState判断失败:", error);
      this.$toast("状态验证失败，请刷新页面重试");
    } finally {
      // 无论成功失败，都隐藏加载状态
      this.globalLoading = false;
    }
  },
  methods: {
    submit() {
      this.$loading.show("提交中");
      this.$http
        .post("/svip-api/jianwei/apply")
        .then((res) => {
          console.log("res", res);
          this.$toast("提交成功!", {
            duration: 2000,
            location: "center", // 默认在中间
          });
          this.$router.replace("/jwRank");
        })
        .catch((err) => {
          this.$toast(err);
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
  },
};
</script>

<style scoped lang="less">
.mIndex {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-right: 0 !important;
  overflow-x: hidden;
  //background-color: #fff;
  background-image: url("~@/assets/images/jwActivity/bg_activity.png");
  background-size: 100% 100%;
  position: relative;

  /* 全局加载遮罩 */
  .global-loading-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #eb698f;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .logoTitle {
    position: absolute;
    left: 28px;
    top: 13px;
    width: 99px;
    height: 18px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .title {
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    top: 43px;
    width: 160px;
    height: 41px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .date {
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    top: 84px;
    font-weight: 400;
    font-size: 14px;
    color: #543d23;
    line-height: 20px;
    text-align: right;
    font-style: normal;
    text-transform: none;
  }

  .ruleContent {
    //border: 1px solid #EB698F;
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    top: 31px;
    width: 315px;
    height: 596px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .submit {
    margin-bottom: 30px;
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    top: 624px;
    width: 290px;
    height: 48px;
    background: #533d24;
    border-radius: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 20px;
    color: #ffffff;
    line-height: 28px;
    letter-spacing: 1px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
